import React from "react";
import { useParams } from "react-router-dom";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useEmployeeProfileFormPage } from "@/modules/administration/features/EmployeeDirectoryManagement/hooks/useEmployeeProfileFormPage";
import EmployeeProfileForm from "@/modules/administration/features/EmployeeDirectoryManagement/components/Profile/EmployeeProfileForm/EmployeeProfileForm";

const EditEmployeeProfilePage: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const pageState = useEmployeeProfileFormPage({ mode: "edit", uuid });

  return (
    <MainPageWrapper
      loading={pageState.loadingFetch}
      title="Edit Employee Profile"
    >
      <EmployeeProfileForm pageState={pageState} />
    </MainPageWrapper>
  );
};

export default EditEmployeeProfilePage;
